import S from 'common/service/sanctuary';
import * as R from 'ramda';
import { createSelector } from 'reselect';

import {
  SORT_ASC,
  SORT_DESC,
} from './reducer';

import {
  selectors as resourceSelectors,
} from '../resource';

import {
  selectors as searchSelectors,
} from '../search';

export const {
  getQuery,
  getSearch,
} = searchSelectors;

export const {
  isLoading,
  getErrorContext,
} = resourceSelectors;

const mapResourceToCollection = R.identity;

export const getCollectionContext = createSelector(
  mapResourceToCollection,
  resourceSelectors.getResourceContext,
);

export const getCollectionMaybe = createSelector(
  mapResourceToCollection,
  resourceSelectors.getResourceMaybe,
);

export const getStoreParams = createSelector(
  ({
    limit,
    offset,
    sort,
  }) => ({
    limit,
    offset,
    sort,
  }),
  getQuery,
  getSearch,
  (params, query, search) => ({
    ...params,
    query,
    search,
  }),
);

export const getTotal = collection => S.chain(
  total => (total > 0 ? S.Just(total) : S.Nothing),
  S.get(S.is(Number), 'total', collection),
);

export const getPaginator = createSelector(
  getTotal,
  getStoreParams,
  (maybeTotal, { limit, offset }) => S.map(total => ({
    limit,
    offset,
    total,
  }), maybeTotal),
);

const getSort = ({ sort }) => sort;

export const getSorter = createSelector(
  getStoreParams,
  ({ sort }) => R.sort({
    [SORT_ASC]: R.ascend,
    [SORT_DESC]: R.descend,
  }[sort.direction](S.prop(sort.property))),
);

export const isSorted = createSelector(
  getSort,
  ({ property, direction } = {}) => property$ => (property === property$ && direction) || null,
);

export const factory = getScope => ({
  ...searchSelectors.factory(getScope),
  ...resourceSelectors.factory(getScope),
  getCollectionContext: createSelector(
    getScope,
    getCollectionContext,
  ),
  getCollectionMaybe: createSelector(
    getScope,
    getCollectionMaybe,
  ),
  getStoreParams: createSelector(
    getScope,
    getStoreParams,
  ),
  isSorted: createSelector(
    getScope,
    isSorted,
  ),
  getPaginator: createSelector(
    getScope,
    getPaginator,
  ),
  getSorter: createSelector(
    getScope,
    getSorter,
  ),
  getTotal: createSelector(
    getScope,
    getTotal,
  ),
});

export default factory;
